module.exports = __webpack_public_path__ + "img/02_4_4_2.28fcca61.png";